// extracted by mini-css-extract-plugin
module.exports = {"root":"HomePage_root__2i6Xj"};